import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { cloneDeep } from 'lodash'
import { EllipsisVertical, Loader2 } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNotificationTemplateActions } from './useNotificationTemplateActions'

type Props = {
  template: Partial<wowaudit.NotificationTemplate>
  setOpenTemplate: (template: Partial<wowaudit.NotificationTemplate>) => void
  setOpenWarningModal?: (templateId: number) => void
}

const TemplateContextMenu = ({
  template,
  setOpenTemplate,
  setOpenWarningModal,
}: Props) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const {
    triggerTestMessage,
    testMessageLoading,
    triggerDeleteTemplate,
    deleteTemplateLoading,
  } = useNotificationTemplateActions(template, {
    onActionComplete: () => setOpen(false),
  })

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger>
        <div className='flex items-center justify-center cursor-pointer h-5'>
          <EllipsisVertical size={18} />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' alignOffset={-10}>
        <DropdownMenuItem onClick={() => setOpenTemplate(cloneDeep(template))}>
          {t('notifications.edit-template')}
        </DropdownMenuItem>

        {setOpenWarningModal && template.id ? (
          <DropdownMenuItem
            onClick={() => setOpenWarningModal(template.id as number)}
          >
            {t('notifications.show-warnings')}
          </DropdownMenuItem>
        ) : null}

        <DropdownMenuItem
          disabled={testMessageLoading}
          onClick={(e) => {
            e.preventDefault()
            if (testMessageLoading) return
            triggerTestMessage()
          }}
          className='w-36'
        >
          {testMessageLoading ? (
            <span className='flex items-center gap-2'>
              <Loader2 className='w-4 h-4 animate-spin' />
              {t('notifications.sending-test-message')}
            </span>
          ) : (
            t('notifications.send-test-message')
          )}
        </DropdownMenuItem>
        <DropdownMenuItem
          disabled={!template.id || deleteTemplateLoading}
          onClick={(e) => {
            e.preventDefault()
            triggerDeleteTemplate()
          }}
          className='text-destructive-foreground focus:text-destructive-foreground'
        >
          {t('notifications.delete-template')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default TemplateContextMenu
